module.exports = __webpack_public_path__ + "static/img/head-h1.9389071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/head-h1.png
// module id = ojJ0
// module chunks = 1